module.exports = __webpack_public_path__ + "static/media/connect-shopify.fb083c1d.png";